import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery } from 'urql';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { cleanupData } from './utils';
import { getCollectionProductSetProducts, getCollectionProductSetProductsSansSwatches } from './queries';
import Collection from '../../components/Collection';
import CollectionLoading from '../../components/CollectionLoading';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CollectionPaginator = function CollectionPaginator(_ref) {
  var initialAfter = _ref.after,
      collection = _ref.collection,
      collectionProductSetId = _ref.collectionProductSetId,
      displayEditorial = _ref.displayEditorial,
      displaySwatches = _ref.displaySwatches,
      initialFilters = _ref.initialFilters,
      initialPaginating = _ref.paginating,
      initialProductSets = _ref.productSets;

  var _useState = useState(initialPaginating),
      _useState2 = _slicedToArray(_useState, 2),
      paginating = _useState2[0],
      setPaginating = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var _useState5 = useState(initialAfter),
      _useState6 = _slicedToArray(_useState5, 2),
      after = _useState6[0],
      setAfter = _useState6[1];

  var _useState7 = useState(initialProductSets),
      _useState8 = _slicedToArray(_useState7, 2),
      productSets = _useState8[0],
      setProductSets = _useState8[1];

  var _useQuery = useQuery({
    query: displaySwatches ? getCollectionProductSetProducts : getCollectionProductSetProductsSansSwatches,
    variables: {
      collectionProductSetId: collectionProductSetId,
      first: 24,
      after: after
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      _useQuery2$ = _useQuery2[0],
      data = _useQuery2$.data,
      fetching = _useQuery2$.fetching,
      error = _useQuery2$.error;

  if (error) {
    console.error('CollectionPaginator', error);
  } // Update the product sets and trigger next page loading


  useEffect(function () {
    var _productSet$products;

    if (!data || fetching || loaded) {
      return;
    }

    var productSet = productSets[0];
    var _data$collectionProdu = data.collectionProductSetProducts,
        edges = _data$collectionProdu.edges,
        pageInfo = _data$collectionProdu.pageInfo;

    if (after === pageInfo.endCursor) {
      return;
    }

    var newProductSets = cleanupData([{
      products: {
        edges: edges
      }
    }], displaySwatches, displayEditorial);
    var currentEdges = (productSet === null || productSet === void 0 ? void 0 : (_productSet$products = productSet.products) === null || _productSet$products === void 0 ? void 0 : _productSet$products.edges) || [];
    setProductSets([_objectSpread(_objectSpread({}, productSet), {}, {
      products: {
        edges: currentEdges.concat(newProductSets[0].products.edges)
      }
    })]);

    if (pageInfo.hasNextPage) {
      setAfter(pageInfo.endCursor);
    } else {
      setLoaded(true);
      setPaginating(false);
    }
  }, [after, data, displayEditorial, displaySwatches, fetching, loaded, productSets]);
  var collectionProps = {
    collection: collection,
    productSets: productSets,
    initialFilters: initialFilters
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Collection, _objectSpread({}, collectionProps)), paginating && /*#__PURE__*/_jsx(CollectionLoading, {
      filterless: true
    })]
  });
};
CollectionPaginator.propTypes = {
  after: PropTypes.string,
  collection: PropTypes.shape({}),
  collectionProductSetId: PropTypes.string,
  displayEditorial: PropTypes.bool,
  displaySwatches: PropTypes.bool,
  initialFilters: PropTypes.arrayOf(PropTypes.shape({})),
  paginating: PropTypes.bool,
  productSets: PropTypes.arrayOf(PropTypes.shape({}))
};